// extracted by mini-css-extract-plugin
export default {"domains":"DomainSuggest-domains_y_P3R","searchResult":"DomainSuggest-searchResult_Jlx1d"};